import { Theme, useMediaQuery } from '@mui/material';

import { DESKTOP_BREAK_POINT } from 'app/constants';

export default function useIsDesktop(breakpoint: number = DESKTOP_BREAK_POINT) {
    return useMediaQuery<Theme>((theme) => theme.breakpoints.up(breakpoint));
}
